<div class="container" *ngIf="appService.theme$ | async as theme">
  <div class="main-container-analyze">
    <div class="table">
      <label class="header">Flight Totals</label>
      <div class="table-container box-shadow"
        [style]="{'background': theme === 'light' ? 'var(--p-surface-0)' : 'var(--p-surface-50)'}">
        <div *ngIf="analyzeData$ | async as data">
          <p-table [value]="data" [dt]="dataTableTotals">
            <ng-template pTemplate="body" let-data>
              @if (data.label === 'Distance Flown') {
                <tr>
                  <td class="item-label">{{ data.label }}</td>
                  <td class="item-value">
                    <button class="units-button" (click)="onUnitsClick(data)">
                      <div class="distance-flown-row">
                        <div>{{ distFlown | number }}</div>
                        <div>{{units}}</div>
                    </div>
                    </button>
                  </td>
                </tr>
              }
              @else {
                <tr>
                  <td class="item-label">{{ data.label }}</td>
                  <td class="item-value">
                    {{ isNumber(data.value) ? (data.value | number) : data.value }}
                  </td>
                </tr>
                }
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
    <div class="table">
      <label class="header">Charts</label>
      <div class="charts-container box-shadow"
        [style]="{'background': theme === 'light' ? 'var(--p-surface-0)' : 'var(--p-surface-50)'}">
        <p-table
          [dt]="dataTableCharts"
          [value]="chartRows" 
          selectionMode="single" 
          dataKey="id" 
          [(selection)]="selectedRow">
          <ng-template #body let-data>
            <tr [pSelectableRow]="data" (click)="onSelectedRow(data)">
              <td>
                <div class="item-label">
                  {{ data.label }}
                </div>
              </td>
              <td>
                <div class="item-value">
                  <i class="pi pi-angle-right"></i>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>